module.exports = __webpack_public_path__ + "static/media/tortoisesvn.f84e3879.webp";